import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { useAuth } from './contexts/AuthContext';
import LoginScreen from './pages/LoginScreen';
import DashboardScreen from './pages/DashboardScreen';
import MyPageScreen from './pages/MyPageScreen';
import ProtectedRoute from './components/ProtectedRoute';
import DatabaseConnectionTest from './components/DatabaseConnectionTest';

function AppContent() {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #fdf2f8 0%, #fce7f3 50%, #fbcfe8 100%)'
      }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.9)',
          borderRadius: '12px',
          padding: '40px',
          textAlign: 'center',
          backdropFilter: 'blur(10px)',
          border: '1px solid #f3e8ff'
        }}>
          <div style={{ marginBottom: '20px' }}>
            <img 
              src="/images/100-day_logo-20251014.png" 
              alt="100日実践" 
              style={{
                width: '60px',
                height: '60px',
                objectFit: 'contain',
                filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))'
              }}
            />
          </div>
          <div style={{
            width: '40px',
            height: '40px',
            border: '3px solid #f3e8ff',
            borderTop: '3px solid #ec4899',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }} />
          <p style={{ color: '#666666', fontSize: '16px' }}>読み込み中...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <DatabaseConnectionTest />
      <Routes>
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <DashboardScreen />
          </ProtectedRoute>
        } />
        <Route path="/mypage" element={
          <ProtectedRoute>
            <MyPageScreen />
          </ProtectedRoute>
        } />
        <Route path="/" element={<Navigate to="/mypage" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;